module.exports = __webpack_public_path__ + "img/box-5.62eb146b.gif";